// 1st Party
import { quote } from './elements';
import { validationEnableButton } from './validation';
import { isMobile } from './utilities';
import './google-maps';
import './event-tracking';

// 3rd Party
import 'bootstrap/js/dist/modal';

// Exit Espanol success message
quote.espanolExit.on('click', function (e) {
    quote.espanolSuccess.hide();

    e.preventDefault();
    e.stopPropagation();
});

// Quote box forward flip
quote.button.on('click', (e) => {
    e.preventDefault();
    quote.flipContainer.addClass('flip');
    setQuoteBackTabIndex('0');
    setQuoteFrontTabIndex('-1');
});

quote.button.on('keypress', (e) => {
    if (e.which === 13) {
        e.currentTarget.click();
    }
});

// Quote box when to allow forward flip
quote.property.fullAddress.on('keyup', validationEnableButton);
quote.property.unitNumber.on('change', validationEnableButton);
quote.newPurchase.on('click', function (e) {
    validationEnableButton(e);
    quote.mailing.fullAddress.prop('readonly', false);
    quote.mailing.unitNumber.prop('readonly', false);
    quote.mailing.fullAddress.removeClass('is-valid');
    quote.mailing.unitNumber.removeClass('is-valid');
    quote.mailing.fullAddress.val('');
    quote.mailing.unitNumber.val('');
    if ($(e.currentTarget).val() === 'true') {
        quote.sameAddress.parents('.form-group').hide();
    } else {
        quote.sameAddress.parents('.form-group').show();
    }
});

// Quote box backward flip
quote.buttonExit.on('click', (e) => {
    e.preventDefault();
    quote.form.find('.wm-input').removeClass('is-invalid');
    quote.flipContainer.removeClass('flip');
    setQuoteBackTabIndex('-1');
    setQuoteFrontTabIndex('0');
});

quote.buttonExit.on('keypress', (e) => {
    if (e.which === 13) {
        e.currentTarget.click();
    }
});

// Quote box product click
quote.products.on('click', (e) => {
    e.preventDefault();
    let activeClass = 'wm-quote-box__product-item-icon--active';
    let currentProduct = $(e.currentTarget);
    let currentOccupancyValue = currentProduct.data('occupancy');
    let currentPolicyValue = currentProduct.data('policy');
    quote.productIcons.removeClass(activeClass);
    quote.occupancyInput.val(currentOccupancyValue);
    quote.policyInput.val(currentPolicyValue);
    currentProduct.find(quote.productIcons).addClass(activeClass);
    validationEnableButton(e);
    quote.addressInputContainer.css('opacity', '1');
    quote.addressInputContainer.css('height', '172px');
    if ($(window).width() > 1200 && quote.heroContainer.height() > 0) {
        quote.heroContainer.css('height', '550px');
    }
    if (quote.agentQuoteContainer.length !== 0) {
        $('.wm-footer-hero').css('margin-top', '225px');
    }
    quote.property.fullAddress.attr('tabindex', '0');
    quote.property.unitNumber.attr('tabindex', '0');
    quote.newPurchase.attr('tabindex', '0');
});

quote.products.on('keypress', (e) => {
    if (e.which === 13) {
        e.currentTarget.click();
    }
});

// Mobile Quote box product click
quote.mobileProducts.on('change', (e) => {
    let currentProduct = $(e.currentTarget).find(':selected');
    let currentOccupancyValue = currentProduct.data('occupancy');
    let currentPolicyValue = currentProduct.data('policy');
    quote.occupancyInput.val(currentOccupancyValue);
    quote.policyInput.val(currentPolicyValue);
    validationEnableButton(e);
    quote.addressInputContainer.css('opacity', '1');
    quote.addressInputContainer.css('height', '223px');
    if (quote.heroContainer.height() > 0) {
        quote.heroContainer.css('height', '395px');
    }
});

// Make sure the same address checkbox is reset
quote.sameAddress.prop('checked', false);

// Quote box address checkbox click
quote.sameAddress.on('change', (e) => {
    let checked = $(e.currentTarget).prop('checked');
    if (quote.googleTypeAheadInput.val() === 'true' && checked && quote.property.addressStreet.val()) {
        quote.mailing.addressStreet.val(quote.property.addressStreet.val());
        quote.mailing.city.val(quote.property.city.val());
        quote.mailing.state.val(quote.property.state.val());
        quote.mailing.zipCode5.val(quote.property.zipCode5.val());
        quote.mailing.zipCode4.val(quote.property.zipCode4.val());
        quote.mailing.country.val(quote.property.country.val());
        quote.mailing.county.val(quote.property.county.val());
        quote.mailing.fullAddress.val(`${quote.property.addressStreet.val()}, ${quote.property.city.val()}, ${quote.property.state.val()} ${quote.property.zipCode5.val()}`);
        quote.mailing.fullAddress.attr('readonly', true).removeClass('is-invalid').addClass('is-valid');
        quote.mailing.unitNumber.val(quote.property.unitNumber.val());
        quote.mailing.unitNumber.attr('readonly', true);
    }
    if (quote.googleTypeAheadInput.val() === 'false') {
        quote.mailing.fullAddress.val(quote.property.fullAddress.val());
        quote.mailing.fullAddress.attr('readonly', true).removeClass('is-invalid').addClass('is-valid');
        quote.mailing.unitNumber.val(quote.property.unitNumber.val());
        quote.mailing.unitNumber.attr('readonly', true);
    }
    if (!checked) {
        quote.mailing.fullAddress.val('');
        quote.mailing.fullAddress.attr('readonly', false).removeClass('is-valid');
        quote.mailing.unitNumber.val('');
        quote.mailing.unitNumber.attr('readonly', false);
    }
});

quote.sameAddress.on('keypress', (e) => {
    if (e.which === 13) {
        e.currentTarget.click();
    }
});

// Quote box when to reset IsPickedFromGoogle
quote.property.fullAddress.on('keydown', function (e) {
    quote.googleTypeAheadInput.val('false');
    quote.property.addressStreet.val('');
    quote.property.city.val('');
    quote.property.state.val('');
    quote.property.zipCode5.val('');
    quote.property.zipCode4.val('');
    quote.property.country.val('');
    quote.property.county.val('');
});

// Set PolicyOriginationMedium based on user agent string
if (isMobile.any()) {
    quote.policyOriginationMediumInput.val('2');
} else {
    quote.policyOriginationMediumInput.val('1');
}

// Scroll to top for quote button on Arizona Home homepage
quote.homeQuoteButton.on('click', function (e) {
    window.scrollTo(0, 0);

    e.preventDefault();
    e.stopPropagation();
});

quote.agentQuoteButton.on('click', function (e) {
    $('.wm-agent-quote__container').show();

    let quoteBoxPosition = quote.quoteBox.position();
    window.scrollTo(0, quoteBoxPosition.top - 69);

    let agentId = $(e.currentTarget).data('agentId');
    quote.salesAgentIdInput.val(agentId);

    let producerCode = $(e.currentTarget).data('producerCode');
    quote.producerCodeInput.val(producerCode);

    const agentLeadSource = 12; // LookUpEnums.LeadSource.Agent
    quote.leadSourceInput.val(agentLeadSource);

    quote.IsAgentPageLeadInput.val(true);

    e.preventDefault();
    e.stopPropagation();
});

quote.form.on('keyup keypress', function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
        e.preventDefault();
        return false;
    }
});

function setQuoteBackTabIndex(value) {
    quote.firstName.attr('tabindex', value);
    quote.middleName.attr('tabindex', value);
    quote.lastName.attr('tabindex', value);
    quote.emailAddress.attr('tabindex', value);
    quote.mailing.fullAddress.attr('tabindex', value);
    quote.mailing.unitNumber.attr('tabindex', value);
    quote.sameAddress.attr('tabindex', value);
    quote.buttonSubmit.attr('tabindex', value);
    quote.buttonExit.attr('tabindex', value);
    quote.ccpa.attr('tabindex', value);
}

function setQuoteFrontTabIndex(value) {
    quote.products.attr('tabindex', value);
    quote.property.fullAddress.attr('tabindex', value);
    quote.property.unitNumber.attr('tabindex', value);
    quote.newPurchase.attr('tabindex', value);
    quote.button.attr('tabindex', value);
}